<div class="flex items-center" *ngIf="pagination?.totalItems">
  <!-- Info -->
  <div
    [matMenuTriggerFor]="menu"
    (menuOpened)="onOpeningMenu()"
    class="flex items-center cursor-pointer text-md font-medium"
    [ngClass]="{
      'pointer-events-none': pagination.lastPage <= pagination.currentPage
    }"
  >
    <span>{{ pagination.startIndex + 1 }}</span>
    <span class="mx-1 text-secondary">-</span>
    <span>{{ pagination.endIndex + 1 }}</span>
    <ng-container *ngIf="pagination.totalItems">
      <span class="mx-1 text-secondary">{{ '/' }}</span>
      <span>{{ pagination.totalItems }}</span>
    </ng-container>
  </div>

  <mat-menu #menu="matMenu" class="px-2 mt-2 shadow">
    <!-- Page input-->
    <mat-form-field
      class="fuse-mat-dense fuse-mat-rounded fuse-mat-no-subscript w-full min-w-50"
    >
      <mat-icon
        class="icon-size-5"
        matPrefix
        [svgIcon]="'feather:corner-up-right'"
      ></mat-icon>
      <input
        (click)="$event.stopPropagation()"
        matInput
        type="number"
        #pageInput
        [formControl]="pageInputControl"
        [autocomplete]="'off'"
        [placeholder]="'Page'"
      />
      <a
        matSuffix
        class="w-8 h-8 min-h-8 ml-2"
        (click)="$event.stopPropagation(); reset()"
        mat-icon-button
      >
        <mat-icon
          class="icon-size-5"
          [svgIcon]="'feather:rotate-ccw'"
        ></mat-icon>
      </a>
    </mat-form-field>

    <!-- Items per page input -->
    <mat-form-field
      class="fuse-mat-dense fuse-mat-rounded fuse-mat-no-subscript mt-2 w-full min-w-50"
    >
      <mat-icon
        class="icon-size-5"
        matPrefix
        [svgIcon]="'feather:list'"
      ></mat-icon>
      <input
        matInput
        type="number"
        #pageInput
        (click)="$event.stopPropagation()"
        [formControl]="itemsPerPageControl"
        [autocomplete]="'off'"
        [placeholder]="'Items per page'"
      />
    </mat-form-field>
  </mat-menu>

  <!-- Previous page button -->
  <a
    class="w-8 h-8 min-h-8 ml-2"
    (click)="goPrev()"
    mat-icon-button
    [disabled]="pagination.currentPage === 1"
  >
    <mat-icon
      class="icon-size-5"
      [svgIcon]="'heroicons_solid:chevron-left'"
    ></mat-icon>
  </a>
  <!-- Next page button-->
  <a
    class="w-8 h-8 min-h-8"
    (click)="goNext()"
    mat-icon-button
    [disabled]="pagination.currentPage === pagination.lastPage"
  >
    <mat-icon
      class="icon-size-5"
      [svgIcon]="'heroicons_solid:chevron-right'"
    ></mat-icon>
  </a>
</div>
